import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import PageContainer from '../page-container';
import Components from '../../components';

import Profile from './profile';
import Telegram from './telegram';
import Promocode from './promocode';
import Vouchers from './vouchers';
import Notifications from './notifications';
import Facebook from './facebook';
import Invite from './invite';

import Triggers from '../../../lib/triggers';

export default () => {
    const location = useLocation();

    useEffect(() => {
        Triggers.page_view({
            page: "freecash"
        });
    }, [location]);

    useEffect(() => {
        Components.Loader.close();
    }, []);

    return (
        <PageContainer>
            <div className="fc-page">
                <Components.Winners />

                <div className="fc-container">
                    {/* <Telegram /> */}
                    {/* <Profile /> */}
                    {/* <Notifications /> */}
                    <Promocode />
                    {/* <Facebook /> */}
                    {/* <Invite /> */}
                    <Vouchers />
                </div>
                <Components.DepositBonus />
                <Components.Footer />
            </div>

        </PageContainer>
    )
}